// extracted by mini-css-extract-plugin
export default {"statsComponent":"Stats_statsComponent__D8Pz3","count":"Stats_count__nLqL3","diggersBlock":"Stats_diggersBlock__WfFAK","diggersBlockList":"Stats_diggersBlockList__AjcP1"};